<template>
    <router-link to="/" aria-label="Перейти на главную страницу">
        <img 
            src="@/assets/big-logo-1x.webp" 
            srcset="@/assets/big-logo-1x.webp 1x, @/assets/big-logo-2x.webp 2x"
            sizes="(max-width: 1024px) 176px, 208px"
            alt="Логотип компании «КРОН»" 
            class="brand-logo"
            width="256"
            height="37"
            fetchpriority="high"
        >
    </router-link>
</template>